<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="arrowRightTopIconTitle"
    stroke="#fff"
    stroke-width="2.5"
    stroke-linecap="square"
    stroke-linejoin="miter"
    fill="none"
  >
    <path d="M19 13V5h-8" />
    <path stroke-linecap="round" d="M19 5l-1 1" />
    <path d="M18 6L5 19" />
  </svg>
</template>